import { useContext, useState } from "react";
import "./NavBar.css";
import logo from "../../assets/logo.svg";
import miniLogo from "../../assets/icon.svg";
import { NavLink } from "react-router-dom";
import AuthContext from "../../context/AuthContext";

import {
  AutoStoriesRounded,
  ChevronLeft,
  ChevronRight,
  DashboardRounded,
  Logout,
  LogoutRounded,
  Style,
} from "@mui/icons-material";
import { Button, IconButton, PopoverPaper, Tooltip } from "@mui/material";
import Teleport from "../Custom/Teleport";
import CustomLink from "./CustomLink";

const NavBar = () => {
  const { logoutUser } = useContext(AuthContext);
  const [navBar, setNavBar] = useState("");
  const [hamburger, setHamburger] = useState("hamburger");

  function toggleMenu(screen) {
    if (screen === "desktop") {
      if (navBar === "") {
        setNavBar("active");
      } else {
        setNavBar("");
      }
    } else if (screen === "mobile") {
      if (hamburger === "hamburger") {
        setHamburger("hamburger open");
      } else {
        setHamburger("hamburger");
      }
    }
  }

  function delayedClose() {
    setTimeout(() => {
      toggleMenu("mobile");
    }, [500]);
  }
  return (
    <div
      className={`position-relative ${navBar === "active" ? "active-nav" : ""}`}
    >
      <ul id="nav-bar" className={navBar} style={{ paddingLeft: "0" }}>
        <li className="part-one">
          <img
            src={navBar === "active" ? logo : miniLogo}
            alt="Assessive Logo"
            className="logo desktop"
          />
          <img src={logo} alt="Assessive Logo" className="logo mobile" />
        </li>
        <li className="part-two">
          {navBar === "active" ? (
            <i
              style={{
                marginLeft: "1rem",
                marginBottom: "0.5rem",
                fontSize: "var(--fontM)",
                color: "var(--icon)",
              }}
            >
              Main Menu
            </i>
          ) : null}

          <CustomLink
            urlTo="/dashboard"
            tooltipDisabled={navBar === "active"}
            title="Dashboard"
            children={<DashboardRounded className="icon" />}
            hidePTag={navBar === ""}
            iconComponent={DashboardRounded}
          />
          <CustomLink
            urlTo="/exams"
            tooltipDisabled={navBar === "active"}
            title="Exams"
            children={<AutoStoriesRounded className="icon" />}
            hidePTag={navBar === ""}
            iconComponent={AutoStoriesRounded}
          />

          <CustomLink
            urlTo="/flashcards"
            tooltipDisabled={navBar === "active"}
            title="Flashcards"
            children={
              <Style className="icon" sx={{ transform: "rotate(90deg)" }} />
            }
            rotate
            hidePTag={navBar === ""}
            iconComponent={Style}
          />
        </li>
        <li className="part-three">
          {navBar === "active" ? (
            <Button
              title="Log Out"
              startIcon={<Logout color="black" className="icon" />}
              onClick={logoutUser}
              className="mx-2 py-2 desktop"
              fullWidth
              disableElevation
              sx={{
                color: "var(--text)",
                fontSize: "12px",
              }}
              variant="contained"
              color="ghostBlack"
            >
              Logout
            </Button>
          ) : (
            <IconButton
              title="Log Out"
              onClick={logoutUser}
              className="desktop"
            >
              <Tooltip
                title={navBar === "active" ? "" : "Log Out"}
                placement="right"
              >
                <LogoutRounded color="black" className="icon" />
              </Tooltip>
            </IconButton>
          )}
          <button
            onClick={() => toggleMenu("mobile")}
            id="menu-btn-mobile"
            className={hamburger}
            title="Toggle Menu"
            aria-labelledby="menu-btn-mobile"
          >
            <span className="hamburger-top"></span>
            <span className="hamburger-middle"></span>
            <span className="hamburger-bottom"></span>
          </button>
          <Teleport>
            <PopoverPaper
              className="mobile-menu"
              square={false}
              sx={{
                boxShadow: "var(--box-shadow)",
                position: "fixed",
                transition: "opacity 0.3s ease-in-out, visibility 0.3s",
                opacity: hamburger === "hamburger" ? 0 : 1,
                visibility: hamburger === "hamburger" ? "hidden" : "visible",
              }}
              onClose={() => toggleMenu("mobile")}
            >
              <ul>
                <li onClick={delayedClose}>
                  <NavLink to="/dashboard" className="menu-link">
                    Dashboard
                  </NavLink>
                </li>
                <li onClick={delayedClose}>
                  <NavLink to="/exams" className="menu-link">
                    Exams
                  </NavLink>
                </li>
                <li onClick={delayedClose}>
                  <NavLink to="/flashcards" className="menu-link">
                    Cards
                  </NavLink>
                </li>
                <li className="no-border">
                  <Button
                    title="Log Out"
                    onClick={logoutUser}
                    className="mobile px-4"
                    size="small"
                    fullWidth
                    disableElevation
                    sx={{
                      color: "white",
                      borderRadius: 50,
                      boxShadow: "none",
                      fontSize: "10px",
                      padding: 0.5,
                    }}
                    variant="contained"
                    color="black"
                  >
                    Log Out
                  </Button>
                </li>
              </ul>
            </PopoverPaper>
          </Teleport>
        </li>
      </ul>
      <button
        className="menu-toggler desktop"
        onClick={() => toggleMenu("desktop")}
      >
        {navBar === "active" ? (
          <ChevronLeft color="iconGray" />
        ) : (
          <ChevronRight color="iconGray" />
        )}
      </button>
    </div>
  );
};

export default NavBar;
